import {
  BusFill30Icon,
  IconComponent,
  MaxitaxiFill30Icon,
  MinibussFill30Icon,
  TaxiFill30Icon,
} from "@vygruppen/spor-icon-react";
import { VehicleType } from "shared/types/alternativeTransport";

export const vehicleTypeToIcon = new Map<VehicleType, [IconComponent, string]>([
  ["BUS", [BusFill30Icon, "Buss"]],
  ["MINIBUS", [MinibussFill30Icon, "Minibuss"]],
  ["TAXI", [TaxiFill30Icon, "Taxi"]],
  ["MAXITAXI", [MaxitaxiFill30Icon, "Maxitaxi"]],
  ["UNKNOWN", [BusFill30Icon, "Ukjent kjøretøy"]],
]);

type Truthy<T> = T extends false | "" | 0 | null | undefined ? never : T; // from lodash

export function truthy<T>(value: T): value is Truthy<T> {
  return !!value;
}
